import type { AssetTypesListBreadcrumbProps } from "./asset-types-list-breadcrumb.type";
import type { BreadcrumbItem } from "@/modules/breadcrumb";

import { Spin } from "antd";

import Breadcrumb from "@/modules/breadcrumb";

import { NO_VALUE } from "./asset-types-list-breadcrumb.constant";

export const AssetTypesListBreadcrumb = ({
  assetTypes,
  isLoading,
}: AssetTypesListBreadcrumbProps) => {
  const items: BreadcrumbItem[] = assetTypes.map(({ id }) => ({
    title: `${id}`,
    href: `/asset-types/${id}`,
    model: "assettype",
  }));

  if (isLoading) {
    return <Spin />;
  }

  if (items.length === 0) {
    return NO_VALUE;
  }

  return <Breadcrumb items={items} />;
};
